import Bridge from 'lib/lib/Bridge'
import { getPlatform } from 'lib/tools/getPlatform'

const bridgeMixin = {
  computed: {
    mixinIsApp() {
      let { isYixinliApp } = getPlatform()
      return isYixinliApp
    },
  },
  methods: {
    getBridge() {
      if (!this.bridge) {
        this.bridge = new Bridge()
      }
      return this.bridge
    },
    /**
     * 打开新的页面，在app中如果isCurrentPageOpen===0会新开webview
     * @param {*} options http://112.124.122.87:8090/pages/viewpage.action?pageId=3311963#id-%E5%A3%B9%E5%BF%83%E7%90%86appnative&h5%E6%8E%A5%E5%8F%A3-openWebView(url)
     */
    /*eslint-disable*/
    openWebView(options = {}) {
      if (!options.url) {
        throw new Error('openWebView需要url参数挂载在options上')
      }
      options = {
        isCurrentPageOpen: 0,
        ...options
      }

      const appVersion = this.$route.query._version
        ? this.$route.query._version
        : null

      if (this.mixinIsApp) {
        const myBridge = this.getBridge()
        if (
          appVersion &&
          ('4.9.4' >= appVersion && getSystem() === 'Android') &&
          this.mixinIsApp
        ) {
          myBridge.call(
            'openWebView',
            encodeURIComponent(JSON.stringify(options))
          )
        } else {
          myBridge.call('openWebView', options)
        }
      } else {
        window.location.href = options.url
      }
    },
    /**
     * 设置标题
     * @param {*} navTitle
     */
    setNavTitle(navTitle) {
      if (this.mixinIsApp) {
        var myBridge = this.getBridge()
        myBridge.call('setTitle', { title: navTitle })
      } else {
        document.title = navTitle
      }
    }
  }
}

export default bridgeMixin
